/**
 * Crop and Photo Configuration
 * Centralized constants for crop modal and photo display
 *
 * Keep these values synchronized to ensure crop data displays consistently
 * across the modal and canvas nodes
 */

export const CROP_CONFIG = {
  // Modal canvas size (total area including padding)
  MODAL_CANVAS_SIZE: 300,

  // Modal crop box size (the visible crop area - what user positions)
  // This is the actual 200x200 area in the center of the 300x300 modal canvas
  MODAL_CROP_BOX_SIZE: 200,

  // Node display size for photo (should match MODAL_CROP_BOX_SIZE for 1:1 correspondence)
  // Set to 200 to match modal crop box - eliminates all scaling math!
  // This ensures what you see in the crop modal is exactly what displays on the canvas node
  NODE_SIZE: 200,

  // Node border radius (rounded corners)
  NODE_BORDER_RADIUS: 8,

  // Minimum and maximum zoom levels for crop modal
  MIN_ZOOM: 0.5,
  MAX_ZOOM: 5.0,
} as const;

/**
 * Validate that modal and node sizes are compatible.
 * They should match to avoid scaling artifacts.
 */
export const validateCropConfig = () => CROP_CONFIG.MODAL_CROP_BOX_SIZE === CROP_CONFIG.NODE_SIZE;
